import { RetirementState } from "@reducers/types/HRM/retirement-state";

import { RetirementActions } from "@actions/HRM/retirement/retirement-actions";
import { CREATE_RETIREMENT, GET_RETIREMENT } from "@actions/HRM/retirement/types";

import {
  getFailedState,
  getRequestingState,
  getSuccessState,
} from "@utils/store";

const initialState: RetirementState = {
  request: false,
};

const retirementReducer = (
  state = initialState,
  actions: RetirementActions
): RetirementState => {
  switch (actions.type) {
    case GET_RETIREMENT.GET_RETIREMENT_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          data: null,
          getRetirementRequestOngoing: true,
          getRetirementSuccess: false,
          getRetirementFailed: false,
        }),
      };
    case GET_RETIREMENT.GET_RETIREMENT_SUCCESS:
      const { payload } = actions as any;
      return {
        ...getSuccessState({
          ...state,
          data: payload.data,
          getRetirementRequestOngoing: false,
          getRetirementSuccess: true,
          getRetirementFailed: false,
        }),
      };
    case GET_RETIREMENT.GET_RETIREMENT_FAILED:
      return {
        ...getFailedState({
          ...state,
          data: null,
          getRetirementRequestOngoing: false,
          getRetirementSuccess: false,
          getRetirementFailed: true,
        }),
      };
    case CREATE_RETIREMENT.CREATE_RETIREMENT_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          createRetirementRequestOngoing: true,
          createRetirementSuccess: false,
          createRetirementFailed: false,
        }),
      };
    case CREATE_RETIREMENT.CREATE_RETIREMENT_SUCCESS: {
      const { payload } = actions as any;

      return {
        ...getSuccessState({
          ...state,
          data: payload.data,
          createRetirementRequestOngoing: false,
          createRetirementSuccess: true,
          createRetirementFailed: false,
        }),
      };
    }
    case CREATE_RETIREMENT.CREATE_RETIREMENT_FAILED:
      return {
        ...getFailedState({
          ...state,
          createRetirementRequestOngoing: false,
          createRetirementSuccess: false,
          createRetirementFailed: true,
        }),
      };
    default:
      return state;
  }
};

export default retirementReducer;
